module.exports = __webpack_public_path__ + "static/CloudStorage-d3b73764f0765897b63d7eeb6a349c78.svg";